var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_1132)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5306 20.9694L16.8366 16.2762C19.6629 12.883 19.3204 7.86693 16.0591 4.88935C12.7978 1.91176 7.77134 2.026 4.64867 5.14867C1.526 8.27134 1.41176 13.2978 4.38935 16.5591C7.36693 19.8204 12.383 20.1629 15.7762 17.3366L20.4694 22.0306C20.7624 22.3237 21.2376 22.3237 21.5306 22.0306C21.8237 21.7376 21.8237 21.2624 21.5306 20.9694ZM3.75 11C3.75 7.27208 6.77208 4.25 10.5 4.25C14.2279 4.25 17.25 7.27208 17.25 11C17.25 14.7279 14.2279 17.75 10.5 17.75C6.77379 17.7459 3.75413 14.7262 3.75 11Z",
    fill: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_1132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.37e076530418faea58dae783d8ba6d6e.svg";
export { ForwardRef as ReactComponent };